<template>
  <div class="progress-ring">
    <svg
      :height="radius * 2"
      :width="radius * 2"
    >
      <defs>
        <linearGradient :id="id" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" :stop-color="darkenColor" />
          <stop offset="50%" :stop-color="progressColor" />
          <stop offset="100%" :stop-color="lightenColor" />
        </linearGradient>
      </defs>

      <circle
        :stroke="!question ? 'white' : '#dbdee9'"
        :stroke-dasharray="`${circumference} ${circumference}`"
        style="strokeDashoffset: 0;"
        :stroke-width="!question ? objectifStroke : stroke"
        fill="transparent"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      />
      <circle
        v-if="!question"
        class="objectif-stroke"
        stroke="#dbdee9"
        :stroke-dasharray="`${objectifCircumference} ${objectifCircumference}`"
        :style="{ strokeDashoffset: objectifStrokeDashoffset }"
        :stroke-width="objectifStroke"
        stroke-linecap="round"
        fill="transparent"
        :r="objectifNormalizedRadius"
        :cx="radius"
        :cy="radius"
      />
      <circle
        class="results-stroke"
        :stroke="`url(#${id})`"
        :stroke-dasharray="`${circumference} ${circumference}`"
        :style="{ strokeDashoffset: strokeDashoffset }"
        :stroke-width="stroke"
        stroke-linecap="round"
        fill="transparent"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      />
    </svg>
    <!-- Show score -->
    <span class="score">
      <strong>{{ progress }}</strong>
      {{ !question ? $t("progress-ring.score-1") : $t("progress-ring.score-2") }}
    </span>
    <!-- if tolltip show it -->
    <template
      v-if="tooltip && tooltipMessage"
    >
      <span class="tolltip">
        <strong v-html="tooltipMessage.results"></strong>
        <span v-html="tooltipMessage.text"></span>
        <span class="triangle"></span>
      </span>
    </template>
  </div>
</template>


<script>
import { lightenDarkenColor } from '@/js/utils/lightenDarkenColor'

// REVIEW: Simple ring color gestion ? when it's greeen ? 50% ?
// REVIEW: Tooltip style!

export default {
  props: {
    radius: {
      type: Number,
      default: () => 40
    },
    stroke: {
      type: Number,
      default: () => 3
    },
    progress: {
      type: Number,
      default: () => 0
    },
    objectif: {
      type: Number,
      default: () => 100
    },
    mandatoryq: {
      type: Number,
      default: () => 100
    },
    requiredmandatoryq: {
      type: Number,
      default: () => 100
    },
    minimum: Number,
    progressquestion: Number,
    questioncount: Number,
    question: Boolean,
    tooltip: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    const normalizedRadius = this.radius - this.stroke * 2
    const circumference = normalizedRadius * 2 * Math.PI

    const objectifStroke = this.stroke * 3.1
    const objectifNormalizedRadius = this.radius - this.stroke * 2
    const objectifCircumference = objectifNormalizedRadius * 2 * Math.PI

    return {
      id: null,
      normalizedRadius,
      circumference,
      objectifStroke,
      objectifNormalizedRadius,
      objectifCircumference,
      color: '#ffa700'
      // color: '#44d22d'
    }
  },

  mounted () {
    this.id = this._uid
  },

  computed: {
    // Stroke Dashoffset
    strokeDashoffset () {
      let percentage
      
      if (this.question) {
        percentage = this.progressquestion / this.questioncount * 100
        if (percentage >= 100) percentage = 100
      } else {
        percentage = this.progress / this.objectif * 100
        if (percentage >= 100) percentage = 100
      }
      return this.circumference - percentage / 100 * this.circumference
    },
    objectifStrokeDashoffset () {
      const percentage = this.minimum / this.objectif * 100
      return this.objectifCircumference - percentage / 100 * this.objectifCircumference
    },
    // color and gradient
    progressColor() {
      let color = '#ffa700'
      if (this.question) {
        color = this.mandatoryq >= this.requiredmandatoryq ? '#44d22d' : '#ffa700'
      } else {
        color = this.progress >= this.minimum ? '#44d22d' : '#ffa700'
      }
      return color
    },
    lightenColor () { return lightenDarkenColor(this.progressColor, 55) },
    darkenColor () { return lightenDarkenColor(this.progressColor, -10) },
    // Tooltip
    tooltipMessage () {
      let message = {results: 0, text: this.$t("progress-ring.tooltip-error")}

      if (this.question) {
        message = this.questioncount <= this.progressquestion &&
                  this.mandatoryq <= this.requiredmandatoryq ?
                  {results: '', text: this.$t("progress-ring.tooltip-5")} :
                  // well done
                  this.requiredmandatoryq > this.mandatoryq ?
                  {results: this.requiredmandatoryq - this.mandatoryq,
                   text: this.$t("progress-ring.tooltip-4")} :
                  // missing mandatory questions
                  this.questioncount > this.progressquestion ?
                  {results: this.questioncount - this.progressquestion,
                   text: this.$t("progress-ring.tooltip-3")} : {results: this.questioncount - this.progressquestion, text: this.$t("progress-ring.tooltip-3")}
      } else {
        message = this.progress > this.minimum ?
                  {results: `+${this.progress - this.minimum}`,
                   text: this.$t("progress-ring.tooltip-1")} : {results: this.minimum - this.progress, text: this.$t("progress-ring.tooltip-2")}
      }
      return message
    }
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
@import '../../styles/components/progress/progress-ring';

</style>
